import { render, staticRenderFns } from "./sightsData.vue?vue&type=template&id=d722a4e0&scoped=true"
import script from "./sightsData.vue?vue&type=script&lang=js"
export * from "./sightsData.vue?vue&type=script&lang=js"
import style0 from "./sightsData.vue?vue&type=style&index=0&id=d722a4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d722a4e0",
  null
  
)

export default component.exports